/**
 * iwoPermissionAssignment Module
 *
 * Description iwo权限分配
 * Author:SMG 2016-6-7
 */
'use strict';
angular.module('iwoPermissionAssignment', ['manageCfg.roleManageMent.permissionAssignment.SavePerModule']).controller('iwoPermissionAssignmentCtrl', [
    '$scope',
    '$timeout',
    '$state',
    '$modal',
    '$compile',
    '$element',
    '$q',
    'localStorageService',
    'trsHttpService',
    'modalDialog',
    'permissionAssignmentService',
    function(
        $scope,
        $timeout,
        $state,
        $modal,
        $compile,
        $element,
        $q,
        localStorageService,
        trsHttpService,
        modalDialog,
        permissionAssignmentService
    ) {
        // 声明将要保存权限的数组对象开始
        var selecetedChanls = {};
        // 声明将要保存权限的数组对象结束
        initData();
        $scope.productAndModule = function() {
            $modal.open({
                templateUrl: './manageConfig/roleManageMent/permissionAssignment/service/productAndModule/productAndModule_tpl.html',
                scope: $scope,
                windowClass: 'manage-authorityAssignment',
                backdrop: false,
                controller: 'productAndModuleCtrl',
            });
        };
        $scope.channelTreeOptions = {
            nodeChildren: 'CHILDREN',
            injectClasses: {
                ul: 'a1',
                li: 'manage-main-rightDiv-leftDiv-treeLi',
                liSelected: 'a7',
                iExpanded: 'a3', // "manage-main-rightDiv-leftDiv-treeIcon",
                iCollapsed: 'a4', // "manage-main-rightDiv-leftDiv-treeIcon",
                iLeaf: 'a5',
                label: 'a6',
                labelSelected: 'a8',
            },
            isLeaf: function(node) {
                return node.HASCHILDREN === 'false';
            },
            isSelectable: function(node) {
                return node.RIGHTVALUE;
            },
            dirSelectable: false,
            allowDeselect: false,
        };
        // 展开树操作
        $scope.showToggle = function(node) {
            if (angular.isDefined(node.CHILDREN) && node.HASCHILDREN === 'true' && node.CHILDREN.length === 0) {
                var params = {
                    serviceid: 'mlf_website',
                    methodname: 'queryChildChannels',
                    ChannelId: node.CHANNELID,
                    RoleId: $scope.roleData.ROLEID,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    node.CHILDREN = data.CHILDREN;
                });
            }
        };

        /**
         * [isAuthorized description] 判断是否已赋权，渲染左侧树节点
         * @param   {[type]}  node  [node description]
         * @return  {[type]}        [return description]
         */
        $scope.isAuthorized = function(node) {
            var flag = false;
            if (angular.isDefined(node.RIGHTINDEX)) {
                var rightIndexs = node.RIGHTINDEX.split(',');
                for (var i = 0; i < rightIndexs.length; i++) {
                    if (node.RIGHTVALUE[parseInt(rightIndexs[i].replace(/\"/g, '')) - 1] === '1') {
                        flag = true;
                    }
                }
            }
            return flag;
        };
        $scope.cTshowSelected = function(sel) {
            permissionAssignmentService.initGroupRight(sel, $scope.roleData.ROLEID).then(function(data) {
                sel.RIGHTID = data; // data;
                delete $scope.rightClassify;
                $scope.authorSelectedNode = sel;
                if (!angular.isArray($scope.authorSelectedNode.RIGHTVALUE)) {
                    $scope.authorSelectedNode.RIGHTVALUE = $scope.authorSelectedNode.RIGHTVALUE.split('');
                    $scope.authorSelectedNode.HASSED = $scope.authorSelectedNode.RIGHTVALUE.indexOf('1') > -1;
                }
                // 将要推送的保存权限对象开始
                var tempId = $scope.authorSelectedNode.OBJID;
                var tempObj = {
                    ID: parseInt($scope.authorSelectedNode.RIGHTID),
                    OPRTYPE: 203,
                    OPRID: parseInt($scope.roleData.ROLEID),
                    OBJTYPE: parseInt($scope.authorSelectedNode.OBJTYPE),
                    OBJID: parseInt($scope.authorSelectedNode.OBJID),
                    NEWVALUE: $scope.authorSelectedNode.RIGHTVALUE,
                };

                selecetedChanls[tempId] = tempObj;
                // 将要推送的保存权限对象结束
                queryRightClassify(sel.CLASSIFY ? sel.CLASSIFY : 'iwo', sel);
            });
        };
        // 处理节点名称，用于应对不同模块类型节点名称显示
        $scope.getNodeDesc = function(node) {
            // angular.element('span.assignedAuthority').each(function(){//用于给父级添加class改变样式
            //     angular.element(this).parent('div.tree-label').addClass('assignedAuthority');
            // });
            return angular.isDefined(node.MODALDESC) ? node.MODALDESC : angular.isDefined(node.DEPARTNAME) ? node.DEPARTNAME : node.CHNLDESC;
        };
        $scope.SavePermissions = function() {
            $modal.open({
                templateUrl: './manageConfig/roleManageMent/permissionAssignment/service/SavePerModule/SavePerModule.html',
                scope: $scope,
                windowClass: 'manageSavePerTemp',
                backdrop: false,
                controller: 'SavePerModuleController',
            });
        };
        // 保存权限开始
        $scope.save = function() {
            var i = 0,
                postRights = [];
            for (var key in selecetedChanls) {
                postRights.push(angular.copy(selecetedChanls[key]));
                postRights[i].NEWVALUE = angular.isArray(postRights[i].NEWVALUE) ? postRights[i].NEWVALUE.join('') : postRights[i].NEWVALUE;
                i++;
            }
            var postRightsString = JSON.stringify(postRights);
            var params = {
                serviceid: 'mlf_extrole',
                methodname: 'saveRight',
                RoleId: $scope.roleData.ROLEID,
                rights: postRightsString,
            };
            if (postRights.length === 0) {
                modalDialog.alertType('您尚未设置权限', '您尚未设置权限', 'error', false);
                return;
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                modalDialog.alertType('保存权限成功', '', 'success', false);
            });
        };
        // 保存权限结束
        // 获取树结束
        /**
         * [queryRightClassify description]  获取权限列表开始
         * @param   {[type]}  classify  [classify description]
         * @param   {[type]}  node      [node description]
         * @return  {[type]}            [return description]
         */
        function queryRightClassify(classify, node) {
            var params = {
                serviceid: 'mlf_extrole',
                methodname: 'queryRightClassify',
                Classify: classify,
            };
            $scope.loadingPromise = trsHttpService.httpServer('/wcm/mlfcenter.do', params, 'get').then(function(data) {
                if ($scope.authorSelectedNode !== undefined) {
                    $scope.rightClassify = data;
                    // 初始化全选按钮开始
                    $scope.initSelectAll();
                    // 初始化全选按钮结束
                }
            });
        }
        // 获取权限列表结束
        // 初始化全选按钮方法开始
        $scope.initSelectAll = function() {
            $scope.rightClassify.selectAll = true;
            for (var i = 0; i < $scope.rightClassify.CHILDREN.length; i++) {
                $scope.rightClassify.CHILDREN[i].selectAll = true;
                for (var j = 0; j < $scope.rightClassify.CHILDREN[i].CHILDREN.length; j++) {
                    if (
                        $scope.authorSelectedNode.RIGHTVALUE.length === 0 ||
                        $scope.authorSelectedNode.RIGHTVALUE[$scope.rightClassify.CHILDREN[i].CHILDREN[j].RIGHTINDEX - 1] == '0'
                    ) {
                        $scope.rightClassify.CHILDREN[i].selectAll = false;
                    }
                }
                if ($scope.rightClassify.CHILDREN[i].selectAll === false) {
                    $scope.rightClassify.selectAll = false;
                }
            }
        };
        // 初始化全选按钮方法结束
        /**
         * [selectTemplateFn description] 选择模板
         * @return {[type]} [description]
         */
        $scope.selectTemplateFn = function() {
            $timeout(function() {
                if (!angular.isArray($scope.selectTemplate.NEWVALUE) && $scope.selectTemplate.NEWVALUE !== undefined) {
                    $scope.authorSelectedNode.RIGHTVALUE = $scope.selectTemplate.NEWVALUE.split('');
                    $scope.authorSelectedNode.HASSED = $scope.authorSelectedNode.RIGHTVALUE.indexOf('1') > -1;
                    var tempObj = {
                        ID: parseInt($scope.authorSelectedNode.RIGHTID),
                        OPRTYPE: 203,
                        OPRID: parseInt($scope.roleData.ROLEID),
                        OBJTYPE: parseInt($scope.authorSelectedNode.OBJTYPE),
                        OBJID: parseInt($scope.authorSelectedNode.OBJID),
                        NEWVALUE: $scope.authorSelectedNode.RIGHTVALUE,
                    };
                    selecetedChanls[$scope.authorSelectedNode.OBJID] = tempObj;
                    // 全选按钮初始化开始
                    $scope.initSelectAll();
                    // 全选按钮初始化结束
                }
            });
        };

        /**
         * [initData description] 初始化数据
         * @return  {[type]}  [return description]
         */
        function initData() {
            $scope.showAuthorizedIcon = false; // 是否显示授权痕迹的小图标
            // 获取从产品列表得到的产品数据开始
            getProductListData();
            // 获取从产品列表得到的产品数据结束
            if ($scope.roleData === undefined) {
                modalDialog.alertType('请先选择角色', '', 'info', false);
                $state.go('manageconfig.rolemanage');
            }
            // 监控左边选择角色是否变动
            $scope.$on('roleData', function(event, roleData) {
                $scope.roleData = roleData;
                selecetedChanls = {};
                getTree();
                delete $scope.rightClassify;
            });
            // 监控左边选择角色是否变动
        }

        /**
         * [getProductListData description] 获取从产品列表得到产品数据开始
         * @return  {[type]}  [return description]
         */
        function getProductListData() {
            var productListData = localStorageService.get('setEditingCenterPermission');
            $scope.moduleName = productListData.MEDIANAME;
            delete $scope.rightClassify;
            delete $scope.siteDesc;
            getTree();
        }
        // 获取从产品列表得到产品数据结束

        /**
         * [getIwoTree description] 获取IWO树开始
         * @param   {[type]}  roleId  [roleId description]
         * @return  {[type]}          [return description]
         */
        function getIwoTree(roleId) {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_modal',
                methodname: 'queryIwoModalsTree',
                RoleId: roleId,
            };
            trsHttpService.httpServer('/wcm/mlfcenter.do', params, 'get').then(function(data) {
                delete data.CHILDREN;
                data.HASCHILDREN = 'false';
                deffer.resolve(data);
            });
            return deffer.promise;
        }

        /**
         * [getDepartTree description] 部门稿库左侧导航树
         * @param   {[type]}  roleId  [roleId description]
         * @return  {[type]}          [return description]
         */
        function getDepartTree(roleId) {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_departdoc',
                methodname: 'queryDeptmentalDocs',
                RoleId: roleId,
            };
            trsHttpService.httpServer('/wcm/mlfcenter.do', params, 'get').then(function(data) {
                defer.resolve(data);
            });
            return defer.promise;
        }

        /**
         * [getTree description] 组装左侧iwo树
         * @return {[type]} [description]
         */
        function getTree() {
            getIwoTree($scope.roleData.ROLEID)
                .then(function(data) {
                    $scope.channelTree = [data];
                    $scope.perSelectedNode = $scope.channelTree[0];
                    $scope.cTshowSelected($scope.channelTree[0]);
                    return getDepartTree($scope.roleData.ROLEID);
                })
                .then(function(data) {
                    data.forEach(function(value, index) {
                        if (value.CHILDREN) {
                            value.CHILDREN.forEach(function(value_, index_) {
                                value_.HASCHILDREN = 'false';
                            });
                        }
                    });
                    $scope.channelTree = $scope.channelTree.concat(data);
                });
        }
        // 获取IWO树结束
    },
]);
